import { useQuery } from '@tanstack/react-query'
import { axiosInstance } from '../../helpers'
import { LeaseAuditEvent } from '../../models'

export const useAuditEventDetail = (
    organizationId: number,
    eventId: number,
) => {
    const eventDetailQueryKey = [
        'audit-event',
        organizationId,
        eventId,
    ] as const

    const {
        data: event,
        isLoading: isLoadingEvent,
        error: errorEvent,
    } = useQuery<LeaseAuditEvent>({
        queryKey: eventDetailQueryKey,
        queryFn: async () => {
            const res = await axiosInstance.get<LeaseAuditEvent>(
                `/document-audit/schedule-event/${eventId}/`,
                {
                    params: {
                        organization_id: organizationId,
                    },
                },
            )
            return res.data
        },
        enabled: !!eventId, // Only run the query if we have an eventId
    })

    return {
        event,
        isLoadingEvent,
        errorEvent,
        eventDetailQueryKey,
    }
}
